import React from "react";
import { Box, Button } from "@origin-digital/ods-core";
import { useUpdateEligibilityActions } from "./hooks/useUpdateEligibiityActions";

function UpdateEligibilityActions() {
  const { handleSubmit, closeDialog, isSubmitting } =
    useUpdateEligibilityActions();

  return (
    <Box display="flex" justifyContent="flex-end" gap="xsmall">
      <Button variant="text" onClick={() => closeDialog()}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={handleSubmit}
        status={isSubmitting ? "loading" : undefined}
      >
        Update eligibility
      </Button>
    </Box>
  );
}
export default UpdateEligibilityActions;
